<template>
  <div class="page-deposit-type"
       page_id="page_deposit_notice">
    <el-row :gutter="20"
            class="first-row">
      <el-col :span="17">
        <div class="grid-content bg-purple">
          <img src="../assets/images/notice.png">
          <span class="notice">{{$t('deposit.type.notice')}}</span>
        </div>
      </el-col>
      <el-col :span="7">
        <div @click="goNext"
             class="grid-content bg-purple-light card-shadow--small"
             :test_id="'deposit_btn_goDetail_' + step.title">
          <span>{{$t('deposit.type.up_button')}}</span>
        </div>
      </el-col>

    </el-row>
    <el-row :gutter="30"
            class="second-row">
      <el-col class="second-row-card-left"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12">
        <el-card class="box-card">
          <div class="card-div">
            <div class="card-title">{{getKey('deposit.index', step.title)}}</div>
            <el-steps direction="vertical" v-if="step.title !== 'fps_deposit'"
                      :active="10">
              <el-step v-for="(item, key) in step.content"
                       :key="key"
                       :title="getKey('deposit.steps', item.stepNumer)"
                       :description="getKey('deposit.steps', item.stepContent)">
                <template slot="icon">
                  <div class="icon-center"></div>
                </template>
                <template slot="description">
                  <div v-html="getKey('deposit.steps',item.stepContent)">
                  </div>
                  <div v-if="item.stepContentList">
                    <div :key="index"
                         v-for="(obj,index) in content[item.stepContentList]">
                      {{obj}}
                    </div>
                  </div>
                </template>
              </el-step>
            </el-steps>
            <div class="process-info" v-else v-html="$t('deposit.fpsDepositProcess')"></div>
          </div>

        </el-card>
        <!-- 温馨提示 -->
        <el-card class="box-card box-card-note">
          <div class="note" v-html="step.title == 'cheque_deposit' ? $t('deposit.chequeNote') : $t('deposit.note')"></div>
        </el-card>
      </el-col>
      <el-col class="second-row-card-right"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="12">
        <el-card class="box-card">
          <div class="card-div">
            <div class="card-title">
              {{step.title == 'fps_deposit' ? $t('deposit.bankAccount.FPS_code') : $t('deposit.bankAccount.eddid_bank_account')}}
            </div>
            <!-- <bPreviewBankNum :isshow="step.title == 'FPS' ? false : true"></bPreviewBankNum> -->
            <!-- <bAccountNumbersSelect v-model="tradeAccount"
                                   @change="change"></bAccountNumbersSelect> -->
            <el-select v-model="tradeAccount"
                       @change="change"
                       :placeholder="$t('deposit.upload.please_sel')">
              <el-option v-for="(item, key) in acountTypeArr"
                         :key="key"
                         :label="getTypeKey('common', item.type)"
                         :value="item.type"></el-option>
            </el-select>
            <div v-if="step.title == 'fps_deposit'"
                 class="fbs-container">
              <!-- 汇丰银行 -->
              <div v-if="fpsHSBCaccount.length">
                <div class="hsbc-box"
                     v-for="(item,index) in fpsHSBCaccount"
                     :key="index">
                  <div class="top">
                    <img class="img-box"
                         :src="require(`@/assets/images/banklogo/${item.keyName || 'OTHER'}.png`)"
                         alt="">
                    <span>{{item.bankNameAuto}}</span>
                  </div>
                  <div class="content">
                    <div class="item">
                      <span class="left">{{$t('deposit.fpsnum') }}</span>
                      <span class="right-text">{{item.bankAccountNumber}}</span>
                    </div>
                    <div class="item">
                      <span class="left">{{$t('deposit.bankCode') }}</span>
                      <span class="right-text">{{item.bankCode}}</span>
                    </div>
                    <div class="item" >
                      <span class="left">{{$t('deposit.receiveName') }}</span>
                      <span class="right-text">{{item.accountNameAuto}}</span>
                    </div>
                    <div>
                    <div class="item" v-for="(val,key) in item.tradingAccountList" :key="key">
                      <span class="left">{{$t('deposit.edAccNum') }}</span>
                      <span class="right-text">{{val.tradeAccountNumber}}</span>
                    </div>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="warn">{{
                      transaccnum(
                        item.tradingAccountList[0] &&
                          item.tradingAccountList[0].tradeAccountNumber
                      )
                    }}</div>
                  </div>
                </div>
              </div>
              <!-- 其他银行 -->
              <div v-if="eddidAccount.length">
                <div class="other-bank-box"
                     v-for="(item,index) in eddidAccount"
                     :key="index">
                  <div class="other-title"
                      v-if="fpsHSBCaccount.length"
                       @click="clickOtherHandle">{{$t('deposit.othertext')}} <i
                       :class="isClickOther?'el-icon-arrow-up':'el-icon-arrow-down'"
                       class="el-icon-arrow"></i>
                  </div>
                  <div class="other-bank-content"
                       v-show="isClickOther">
                    <div class="top">
                      <img class="img-box"
                           :src="require(`@/assets/images/banklogo/${item.keyName || 'OTHER'}.png`)"
                           alt="">
                      <span>{{item.bankNameAuto}}</span>
                    </div>
                    <div class="content">
                      <div class="item">
                        <span class="left">{{$t('deposit.fpsnum') }}</span>
                        <span class="right-text">{{item.bankAccountNumber}}</span>
                      </div>
                      <div class="item">
                        <span class="left">{{$t('deposit.bankCode') }}</span>
                        <span class="right-text">{{item.bankCode}}</span>
                      </div>
                      <div class="item">
                        <span class="left">{{$t('deposit.receiveName') }}</span>
                        <span class="right-text">{{ item.accountNameAuto}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            <el-tabs v-model="activeName"
                     @tab-click="change('')"
                     v-else>
              <el-tab-pane v-for="(item, key) in currencyTabs"
                           :key="key"
                           :name="item.name"
                           :test_id="'deposit_' +item.name ">
                <span slot="label">
                  <img style="vertical-align: middle; margin-right: 10px;"
                       :src="item.image"
                       width="30"
                       height="20"
                       alt="">
                  <b style="font-size: 14px; vertical-align: middle;">{{getTypeKey('deposit', item.name)}}</b>
                </span>

                <el-collapse>
                  <el-collapse-item v-for="(item, key) in bankAccountArray"
                                    :key="key"
                                    :test_id="item.test_id">
                    <template slot="title">
                      <img style="vertical-align: middle; margin-right: 10px;"
                           width="50"
                           :src="item.icon"
                           alt="icon">
                      <span v-if="step.title !== 'fps_deposit'">
                        <span v-show="item.bank_name">{{item.bank_name}}</span>
                        <span v-show="item.fps_title">{{item.fps_title}}</span><br>
                        <span v-show="item.payee_number">{{$t('deposit.payee_number')}}：{{item.payee_number}}</span>
                        <span v-show="item.bank_number">{{$t('deposit.bank_number')}}：{{item.bank_number}}</span>
                        <span v-show="item.fps_code">{{$t('deposit.identifier')}}：{{item.fps_code}}</span>
                      </span>
                      <span v-else>
                        <span v-show="item.fps_code">{{$t('deposit.identifier')}}：{{item.fps_code}}</span>
                      </span>
                    </template>
                    <div v-if="step.title !== 'fps_deposit'">
                      <p v-show="item.account_name">{{$t('deposit.account_name')}}：<b>{{item.account_name}}</b></p>
                      <p v-show="item.payee_name">{{$t('deposit.payee_name')}}：<b>{{item.payee_name}}</b></p>
                      <p v-show="item.swift_code">{{$t('deposit.swift_code')}}：<b>{{item.swift_code}}</b></p>
                      <p v-show="item.accountName">
                        {{$t('deposit.beneficiaryAccount')}}：<b>
                          <!-- <span>{{item.accountName}}</span> -->
                          <span >{{item.accountNameEn}}</span>
                        </b></p>
                      <p v-show="item.address">{{$t('deposit.bank_address')}}：<b><span>{{item.address}}</span>
                          <div style="padding-left:113px" v-if="!isEn">{{item.enAddress}}</div>
                        </b></p>
                    </div>
                    <div v-else>
                      <p v-show="item.bank_name">{{$t('deposit.receiveBankName')}}：<b>{{item.bank_name}}</b></p>
                      <p v-show="item.bankCode">{{$t('deposit.bankCode')}}：<b>{{item.bankCode}}</b></p>
                      <p v-show="item.accountName">{{$t('deposit.receiveName')}}：<b>{{item.accountName}}</b></p>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <br>
              </el-tab-pane>
            </el-tabs>

          </div>
        </el-card>
      </el-col>

    </el-row>
  </div>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
// import eddidAccountInfo from '@/views/apps/deposit/accountInfo'
// import deposit from '../views/table-config/deposit'
import {
  getBanksList,
  getEddidBanks,
  getSubAccountList
} from '@/api/v2/deposit'
export default {
  props: { step: Object },
  data() {
    return {
      language: true,
      bankAccountArray: [],
      activeName: 'HKD',
      currencyArr: [
        {
          image: require('@/assets/images/currency/存入港币.png'),
          title: this.$t('accountInfo.currencyOpt.HKD'),
          name: 'HKD',
          test_id: 'deposit_currency_hkd'
        },
        {
          image: require('@/assets/images/currency/存入美元.png'),
          title: this.$t('accountInfo.currencyOpt.USD'),
          name: 'USD',
          test_id: 'deposit_currency_usd'
        },
        {
          image: require('@/assets/images/currency/存入人民币.png'),
          title: this.$t('accountInfo.currencyOpt.CNY'),
          name: 'CNY',
          test_id: 'deposit_currency_cny'
        }
      ],
      currencyTabs: [],
      bankSubAccountArr: [],
      acountTypeArr: [],
      typeValue: '',
      tradeAccountTypeValue: '',
      selectAccount: '',
      tradeAccount: '',
      eddidAccount: '',
      isClickOther: false,
      fpsHSBCaccount: []
    }
  },
  computed: {
    ...mapGetters([
      'getUser',
      'valueAccountNumber',
      'getClientProfile',
      'getAccountInfo',
      'getSubBankAccounts'
    ]),
    ...mapState(['accountInfo', 'subBankAccounts', 'userInfo']),
    tradeAccountList() {
      return this.accountInfo.filter(item => item.type !== 'FOREX')
    },
    content() {
      return this.$t('deposit.steps')
    },
    isEn() {
      return sessionStorage.getItem('language') === 'en'
    }
  },
  mounted() {
    this.getAcountType()
    console.log(sessionStorage.getItem('language'), '----')
  },
  watch: {},
  methods: {
    transaccnum(val) {
      if (val) {
        return this.$t('deposit.fpsWarn')
      }
    },
    clickOtherHandle() {
      this.isClickOther = !this.isClickOther
    },
    tradeAccountConfig(tradeAccountType) {
      return this.Util.getTradeAccountConfig(tradeAccountType)
    },
    getTypeKey(arr, key) {
      let item = this.$t(arr)
      return item[key] ? item[key] : key
    },
    async getAcountType() {
      this.acountTypeArr = this.tradeAccountList
      for (let i = 0; i < this.acountTypeArr.length; i++) {
        let enabled = this.acountTypeArr[i].status
        this.acountTypeArr[i].enabled = enabled
      }
      let obj = {}
      this.acountTypeArr = this.acountTypeArr.reduce((newArr, next) => {
        if (next.tradeAccountType !== 'VA') {
          // eslint-disable-next-line no-unused-expressions
          obj[next.type] ? '' : (obj[next.type] = true && newArr.push(next))
        }
        return newArr
      }, [])
    },
    async change(val) {
      this.isClickOther = false
      if (val) {
        this.selectAccount = val
        this.tradeAccount = val
      }
      // this.typeValue = this.selectAccount.type
      // this.tradeAccountTypeValue = this.selectAccount.tradeAccountType
      // let eddidAccount = eddidAccountInfo[this.tradeAccountTypeValue] || []
      // if (
      //   !(
      //     this.tradeAccountConfig(this.tradeAccountTypeValue) &&
      //     // eslint-disable-next-line standard/computed-property-even-spacing
      //     this.tradeAccountConfig(this.tradeAccountTypeValue)[
      //       'isTradeAccountExit'
      //     ]
      //   )
      // ) {
      //   // eslint-disable-next-line no-throw-literal
      //   throw { code: '5003', msg: 'tradeAccountType is lost' }
      // }
      this.currencyTabs = []
      let tradeType =
        this.step.title === 'sub_account_deposit' ? '' : this.selectAccount
      if (this.step.title === 'sub_account_deposit') {
        await this.getSubAccountList()
      } else {
        await this.getEddidBanks(tradeType, this.activeName)
      }

      if (this.step.title === 'fps_deposit') {
        this.currencyTabs.push(this.currencyArr[0])
        this.getBankAccountArray(this.eddidAccount, 'type', 'FPS')
        //  this.getBankAccountArray(this.eddidAccount, 'currency', this.activeName)
      } else if (this.step.title === 'sub_account_deposit') {
        this.currencyTabs.push(this.currencyArr[0])
        this.getBankAccountArray(this.eddidAccount, 'currency', this.activeName)
      } else {
        this.currencyTabs = this.currencyArr
        this.getBankAccountArray(this.eddidAccount, 'currency', this.activeName)
      }
    },
    getBankAccountArray(arr, key, val) {
      this.bankAccountArray = arr.filter(function(obj) {
        return obj[key] === val
      })
      return this.bankAccountArray
    },
    getKey(arr, key) {
      let item = this.$t(arr)
      return item[key] ? item[key] : key
    },
    goNext() {
      // this.$router.push('/upload-deposit-reciept')
      this.$router.push({
        path: '/upload-deposit-reciept',
        query: { stepTitle: this.step.title }
      })
    },
    // 获取银行信息
    async getBankInfo() {
      try {
        let res = await getBanksList({
          addressType: 'HongKong'
        })
        let filterArr = ['JPY', 'SGD', 'MYR', 'IDR'] // 过滤东南亚二期币种
        let data = res.data.filter(item => {
          return !filterArr.includes(item.currency)
        })
        return data
      } catch (e) {
        e.msg && this.$message.error(e.msg)
      }
    },
    // 查询艾德银行帐户
    async getEddidBanks(tradeType, currency) {
      let OTHER = 'OTHER'
      try {
        let depositType = this.step.title && this.step.title.toUpperCase()
        console.log(depositType, 'depositType')
        let type = ''
        if (depositType === 'FPS_DEPOSIT') {
          type = 'FPS'
        } else {
          type = 'COMMON'
        }
        let params = {
          type: type,
          tradeAccountTypeList: [tradeType],
          currency: currency || 'HKD'
        }
        let { data } = await getEddidBanks(params)
        if (this.step.title === 'fps_deposit') {
          console.log(data, 'data')
          let fpsAccount =
            data.filter(
              item => item.type === 'FPS' && item.keyName === 'HSBC'
            ) || []
          let accArr = []
          this.fpsHSBCaccount = fpsAccount.map(item => {
            item.tradingAccountList.map(val => {
              accArr.push(val.tradeAccountNumber)
            })
            return {
              ...item,
              hsbcAccount: accArr.join('、')
            }
          })
          if (!this.fpsHSBCaccount.length) {
            this.isClickOther = true
          }
          this.eddidAccount =
            data.filter(
              item => item.type === 'FPS' && item.keyName !== 'HSBC'
            ) || []
          // this.eddidAccount = fpsAccount.map(item => {
          //   return {
          //     icon: require('@/assets/images/deposit/FPS-e.png'),
          //     fps_code: item.bankAccountNumber,
          //     keyName: item.keyName,
          //     type: item.type,
          //     bank_number: item.bankAccountNumber,
          //     swift_code: item.swiftCode,
          //     bank_name: item.bankNameAuto,
          //     payee_name: item.payeeName,
          //     accountName: item.accountNameAuto,
          //     bankCode: item.bankCode
          //   }
          // }) || []
          console.log(this.eddidAccount, 'this.eddidAccount')
        } else {
          this.eddidAccount =
            data.map(item => {
              return {
                currency: item.currency,
                icon: require(`@/assets/images/banklogo/${item.keyName ||
                  OTHER}.png`),
                bank_number: item.bankAccountNumber,
                swift_code: item.swiftCode,
                address: item.addressAuto,
                bank_name: item.bankNameAuto,
                payee_number: item.payee_number,
                payee_name: item.payeeName,
                enAddress: item.enAddress,
                accountName: item.accountNameAuto,
                accountNameEn: item.accountNameEn
              }
            }) || []
        }
      } catch (e) {
        this.$message.error(e)
      }
    },
    // 查询子账户
    async getSubAccountList() {
      let res = await getSubAccountList()
      if (res && res.code === 200) {
        this.eddidAccount =
          res.data &&
          res.data.map(item => {
            return {
              currency: item.currency,
              icon: require(`@/assets/images/banklogo/${item.bankKey ||
                'OTHER'}.png`),
              bank_number: item.account,
              swift_code: item.swiftCode,
              address: item.address,
              bank_name: item.name,
              payee_number: item.payee_number,
              payee_name: item.payeeName,
              enAddress: item.aliasAddress,
              accountNameEn: item.accountNameEn
            }
          })
      }
    }
  }
}
</script>
<style lang='scss'>
.page-deposit-type {
  .el-select {
    width: 100%;
  }
  .el-collapse {
    border-top: none;
    border-bottom: none;
  }
  .el-collapse-item {
    padding: 10px 0 0 10px;
    margin-bottom: 10px;
    border: 1px solid #ebeef5;
    border-radius: 5px;
    -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  }
  .el-collapse-item__header {
    height: 100px;
    line-height: 50px;
    font-size: 14px;
    color: #999;
    // display: flex;
  }
  .el-collapse-item__arrow {
    line-height: 100px;
  }
  .el-collapse-item__content {
    font-size: 14px;
    color: #999;
  }
  .note {
    font-size: 12px;
    font-weight: 400;
    color: #666666;
    line-height: 18px;
  }
  .bg-purple {
    background: #fff2cc;
    text-align: left !important;
    vertical-align: middle;
  }
  .bg-purple img {
    vertical-align: middle;
    margin-left: 1rem;
  }
  .bg-purple span {
    height: 100%;
    vertical-align: middle;
    display: inline-block;
    margin-left: 1rem;
  }
  .grid-content {
    // border-radius: 4px;
    min-height: 3.5rem;
    text-align: center;
    line-height: 3.5rem;
    white-space: nowrap;
  }
  @media only screen and (max-width: 1920px) {
    .grid-content span {
      font-size: 14px !important;
      font-weight: bold;
    }
  }
  @media only screen and (max-width: 1200px) {
    .grid-content span {
      font-size: 8px !important;
      font-weight: bold;
    }
  }
  @media only screen and (max-width: 992px) {
    .grid-content span {
      font-size: 12px !important;
    }
  }
  @media (max-width: 768px) {
    .layout-container .container .view {
      max-width: 100%;
      padding: 0px;
      margin: 0;
    }
    .notice {
      white-space: normal;
      overflow: hidden;
      line-height: initial;
      padding-right: 52px;
    }
    .first-row {
      margin-left: 0 !important;
      margin-right: 0 !important;
    }
  }
  .grid-content .el-step__title {
    color: #b4bcce !important;
  }
  .el-step__icon-inner {
    width: 0.8rem !important;
    height: 0.8rem !important;
    background-color: #b4bcce !important;
    border-radius: 0.8rem;
  }
  .el-step__icon {
    background-color: #e8ecf8 !important;
    width: 18px;
    height: 18px;
    line-height: 18px;
  }
  .el-step__head.is-finish {
    border-color: #e8ecf8;
    color: #e8ecf8;
  }
  .el-step.is-vertical .el-step__line {
    left: 9px;
  }
  .bg-purple-light {
    background-color: #fec000;
    cursor: pointer;
    border-radius: 5px;
  }
  .bg-purple-light img {
    width: 10%;
  }
  .first-row {
    margin-top: 1.5rem;
    margin-bottom: 27px;
    padding-bottom: 30px;
    border-bottom: 2px solid #ebebeb;
  }
  .second-row {
    height: 40rem;
  }
  .page-deposit-type {
    .el-step__icon-inner {
      color: #182a54 !important;
    }
  }
  .card-div {
    .el-step__title {
      color: #000;
      font-weight: bold;
      font-size: 14px;
    }
    .el-step__description {
      color: #666 !important;
      font-size: 13px;
      padding: 0 0 15px 0;
    }
    .card-title {
      font-family: Muli-Bold;
      font-size: 18px;
      color: #182a54;
      letter-spacing: 0.22px;
      line-height: 18px;
      margin-bottom: 22px;
      padding-bottom: 22px;
      border-bottom: 3px solid #ebebeb;
    }
    .icon-center {
      width: 10px;
      height: 10px;
      background: #b4bcce;
      border-radius: 50%;
    }
    .process-info {
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 21px;
    }
  }
  .img-div {
    width: 20%;
    text-align: center;
    display: inline-block;
  }
  .img-div img {
    width: 40%;
  }
  .account-div {
    width: 80%;
    display: inline-block;
  }
}
.fbs-container {
  padding-top: 20px;
}
.box-card {
  margin-bottom: 20px;
}
.box-card-note {
  border-left: 4px solid #fec000;
}
.hsbc-box {
  padding: 20px;
  background: #f9fafd;
  border-radius: 4px;
  margin-bottom: 24px;
  .top {
    padding-bottom: 13px;
    border-bottom: 1px solid #eeeeee;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    .img-box {
      width: 22px;
      height: 22px;
      margin-right: 10px;
    }
    span {
      font-size: 15px;
      font-weight: 500;
      color: #333333;
      line-height: 15px;
    }
  }
  .content {
    .item {
      display: flex;
      margin-bottom: 15px;
      font-size: 14px;
      font-weight: 400;
      line-height: 21px;
      .left {
        min-width: 160px;
        color: #6d748f;
        margin-right: 10px;
      }
      .right-text {
        color: #333333;
        flex: 1;
      }
    }
  }
  .bottom {
    font-size: 15px;
    font-weight: 600;
    color: red;
    line-height: 21px;
    .account-box {
      color: #333333;
    }
  }
}
.other-bank-box {
  .other-title {
    font-size: 15px;
    font-weight: 400;
    color: #3773e1;
    line-height: 15px;
    margin-bottom: 15px;
    text-align: center;
    cursor: pointer;
    .el-icon-arrow {
      font-weight: 600;
      font-size: 14px;
    }
  }
  .other-bank-content {
    @extend .hsbc-box;
  }
}
</style>
